"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthServiceStub = void 0;
const faker = __importStar(require("faker"));
const dummyUser = {
    displayName: faker.name.findName(),
    uid: faker.random.uuid(),
    email: faker.internet.email(),
};
class AuthServiceStub {
    // Future use is possible
    // eslint-disable-next-line
    constructor() { }
    async loginWithUsernameAndPassword(username, password, _) {
        if (username && password) {
            return {
                status: true,
                message: "User account status",
                payload: null,
            };
        }
        return null;
    }
    async signUp(user, selectedPlanName) {
        if (user && selectedPlanName) {
            return faker.random.alphaNumeric(12);
        }
        return null;
    }
    signOut() {
        return null;
    }
    async currentUser() {
        return dummyUser;
    }
    async getIdToken() {
        return faker.random.alphaNumeric(12);
    }
    async isPasswordSignInAvailable(identifier) {
        return Boolean(identifier);
    }
    async getAvererInvitation() {
        return { status: true, message: "Invitation found", payload: { companyName: "", email: "", name: "" } };
    }
    async startAvererSignIn() {
        return undefined;
    }
    async completeAvererSignIn() {
        return {
            status: true,
            message: "Login successful",
            payload: { returnTo: "/" },
        };
    }
    async createNomineeAccount(userId, createNomineeAccountRequestBody) {
        if (userId && createNomineeAccountRequestBody) {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "Account created successfully",
                    payload: "some-token",
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Unable to create new account",
                        payload: null,
                    });
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
            status: false,
            message: "Invalid request",
            payload: null,
        });
    }
    async createInvestorAccount(userId, createInvestorRequestBody) {
        if (userId && createInvestorRequestBody) {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "Account created successfully",
                    payload: "some-token",
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Unable to create new account",
                        payload: null,
                    });
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
            status: false,
            message: "Invalid request",
            payload: null,
        });
    }
    async createAdminAccount(adminUserId, companyId, createNewAdminAccountRequestBody) {
        if (adminUserId && companyId && createNewAdminAccountRequestBody) {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "Account created successfully",
                    payload: "some-token",
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Unable to create new account",
                        payload: null,
                    });
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
            status: false,
            message: "Invalid request",
            payload: null,
        });
    }
    async onAuthStateChanged(callback) {
        callback(dummyUser);
    }
}
exports.AuthServiceStub = AuthServiceStub;
//# sourceMappingURL=AuthServiceStub.js.map